import React from "react";
import "./skills.scss";

// const columns = [
//   {
//     id: "product-uxui",
//     title: "Product Design & UX/UI",
//     subtitle: "User research to high-fidelity interfaces",
//     icon: (
//       <svg className="skills__iconSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
//         <rect x="3" y="3" width="7" height="7" rx="1" />
//         <rect x="14" y="3" width="7" height="7" rx="1" />
//         <rect x="3" y="14" width="7" height="7" rx="1" />
//         <rect x="14" y="14" width="7" height="7" rx="1" />
//       </svg>
//     ),
//     tags: [
//       { label: "Usability & accessibility (WCAG)", title: "A11y, inclusive design" },
//       { label: "High-fidelity prototyping (Figma)", title: "Interactive prototypes" },
//       { label: "User research & problem analysis", title: "Research, empathy, context" },
//       { label: "Interaction flows & decision logic", title: "User flows, decision trees" },
//       { label: "Design trade-offs & iteration", title: "Prioritization, iteration" },
//       { label: "Component-based interface design & design systems", title: "Reusable UI patterns, tokens, handoff" },
//     ],
//   },
//   {
//     id: "frontend",
//     title: "Front-End Development",
//     subtitle: "Design-to-code, production-ready interfaces",
//     icon: (
//       <svg className="skills__iconSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" />
//       </svg>
//     ),
//     tags: [
//       { label: "React (JS)", title: "Component-based UI, Hooks" },
//       { label: "React component architecture", title: "Composition, patterns" },
//       { label: "HTML5, CSS3 & SASS", title: "Semantic markup, layout, styling" },
//       { label: "Responsive & adaptive layouts", title: "Breakpoints, mobile-first" },
//       { label: "REST APIs & JSON integration", title: "Data, integration" },
//       { label: "Version control (Git)", title: "Collaboration, workflow" },
//       { label: "CI/CD", title: "Continuous integration & deployment" },
//       { label: "Design-to-code implementation", title: "Pixel-accurate implementation" },
//     ],
//   },
// ];


const columns = [
  {
    id: "software-engineering",
    title: "Software Engineering",
    subtitle: "Systems, architecture, and application development",
    icon: (
      <svg className="skills__iconSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" />
      </svg>
    ),
    tags: [
      { label: "JavaScript / TypeScript", title: "Application development" },
      { label: "Java & Python", title: "General-purpose programming" },
      { label: "React & component architecture", title: "Modular UI systems" },
      { label: "REST APIs & JSON data pipelines", title: "Client–server communication" },
      { label: "System design & application architecture", title: "Software structure and scalability" },
      { label: "Performance optimization", title: "Efficiency, state management" },
      { label: "Git & collaborative workflows", title: "Version control" },
      { label: "CI/CD & deployment workflows", title: "Build and deployment automation" },
    ],
  },
  {
    id: "product-uxui",
    title: "Product & UX Thinking",
    subtitle: "User-centered problem solving",
    icon: (
      <svg className="skills__iconSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
    ),
    tags: [
      { label: "User research & problem analysis", title: "Understanding user needs" },
      { label: "Interaction flows & decision logic", title: "UX architecture and logic" },
      { label: "Usability & accessibility (WCAG)", title: "Inclusive design principles" },
      { label: "High-fidelity prototyping (Figma)", title: "Interactive design prototypes" },
      { label: "Design iteration & trade-offs", title: "Prioritization and refinement" },
      { label: "Component-based interface thinking", title: "Reusable UI patterns" },
    ],
  },
];



function SkillTag({ label, title }) {
  return (
    <span className="skills__tag" title={title}>
      {label}
    </span>
  );
}

export default function Skills() {
  return (
    <div className="skills" id="skills">
      <div className="skills__inner">
        <h2 className="skills__pageTitle">Skills</h2>
        <p className="skills__subtitle">
          Design &amp; development — clearly separated
        </p>

        <div className="skills__grid">
          {columns.map((col) => (
            <section key={col.id} className="skills__card">
              <div className="skills__iconWrap" aria-hidden="true">
                {col.icon}
              </div>
              <h3 className="skills__cardTitle">{col.title}</h3>
              <p className="skills__cardSubtitle">{col.subtitle}</p>
              <div className="skills__tags">
                {col.tags.map((t, i) => (
                  <SkillTag key={i} label={t.label} title={t.title} />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
